import styled from 'styled-components';

export const SelectDateContainer = styled.div`
  padding: 0 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const Label = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 1.2;
  color: ${(p) => p.theme.colors.blue.dark};
  margin-right: 10px;
`;
